import { BordOneToneIcon, NudosButton } from 'components/NudosComponents';
import EditableServiceRow from '../EditableServiceRow/EditableServiceRow';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { ILogisticServiceEditionForm } from '../../LogisticServiceEdition.types';
import './ToolServicesEdition.scss';

interface IToolServicesEditionProps {
  serial?: string;
  productIndex: number;
}

const ToolServicesEdition = ({ serial, productIndex }: IToolServicesEditionProps) => {
  const { control, getValues } = useFormContext<ILogisticServiceEditionForm>();
  const {
    fields: services,
    append,
    remove
  } = useFieldArray({
    control,
    name: `products.${productIndex}.logisticServiceProductPrices`
  });

  return (
    <section className="toolServiceEdition">
      <div className="toolSerial">
        <BordOneToneIcon variant="barCode2" customWidth="16px" stroke="black" standardSize={32} />
        <span>Serial:</span>
        <span>{serial}</span>
      </div>
      {services && services.length > 0 &&
        services.map((service, index) => (
          <EditableServiceRow
            key={service.id || `${productIndex}-${index}`}
            removeAction={() => remove(index)}
            registerReference={`products.${productIndex}.logisticServiceProductPrices.${index}`}
            productName={getValues(`products.${productIndex}.product.name`) || ''}
            productSerial={serial || ''}
          />
        ))}
      <hr className="divider" />
      <NudosButton
        type="button"
        buttonText={'Agregar otro ítem'}
        buttonIcon={<BordOneToneIcon variant="plus" customWidth="12px" stroke="black" />}
        colorPalette="secondary"
        customClassName="addItem"
        handleClick={() => append({})}
      />
    </section>
  );
};

export default ToolServicesEdition;
